
import { useEffect } from "react";
import * as yup from 'yup';
import { useAppDispatch, useAppSelector } from "../../../redux/hooks";

import { Button, Divider, Grid, Typography } from "@mui/material";
import { ErrorMessage, Field, Form, Formik } from 'formik';
import { ISubActivity } from "../../../models/subActivities";

import { editSubActivity, getActivities, RootState, saveSubActivity } from "../../../redux";
import '../../../themes/styles.css';

interface Props {
    onCancel: () => void,
    subActivity: ISubActivity,
    editing: boolean
}

export const MyForm = ({ onCancel, subActivity, editing }: Props) => {
    const dispatch = useAppDispatch();

    useEffect(() => {
        dispatch(getActivities() as any);
    }, [dispatch])

    const { activities = [] } = useAppSelector((state: RootState) => state.activities);

    const onSave = (subActivity: ISubActivity) => {
        editing ? dispatch(editSubActivity(subActivity) as any) : dispatch(saveSubActivity(subActivity) as any);
    }

    return (
        <Grid>
            <Typography id="modal-modal-title" variant="h6" component="h2">
                Add Sub Activity
            </Typography>
            <br />
            <Divider />
            <br />

            <Formik
                initialValues={subActivity}
                onSubmit={(values) => {
                    onSave(values as any);
                    onCancel();
                }}
                validationSchema={yup.object({
                    activityId: yup.string()
                        .required('You must choose an activity'),
                })}
            >
                {(formik) => (
                    <Form>
                        <Grid container justifyContent="center" rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
                            <Grid item xs={6}>
                                <Typography component="label" htmlFor="name">Name</Typography>
                                <Field name="name" type="text" />
                                <ErrorMessage name="name" component="span" className="error-message" />
                                <br />
                            </Grid>
                            <Grid item xs={6}>
                                <Typography component="label" htmlFor="activityId">Activity</Typography>
                                <Field name="activityId" as="select">
                                    <option value="">Select an Activity</option>
                                    {
                                        activities.map((activity) =>
                                            <option key={activity.id} value={activity.id}>{activity.name}</option>
                                        )
                                    }
                                </Field>
                                <ErrorMessage name="activityId" component="span" className="error-message" />
                            </Grid>
                        </Grid>
                        <br />
                        <Grid container justifyContent="center">
                            <Button variant="outlined" type="reset" sx={{ width: 100 }} onClick={onCancel}>Cancel</Button>
                            &nbsp;&nbsp;&nbsp;
                            <Button variant="contained" type="submit" sx={{ width: 100 }} >Save</Button>
                        </Grid>
                    </Form>
                )}
            </Formik>
        </Grid >
    )
}

